import {
  deleteOfflineLogImportRecord,
  getAttackType,
  getDetailAttCkList,
  getOfflineLogImportInfo,
  getResultDefenseRankings,
  getResultDeviceOption,
  getResultInfo,
  getResultPluginList,
  getResultRingPattern,
  getResultRiskLevel,
  getResultTemplateRankings,
  getTagTreeOptions,
  updateResourceInterceptStatus,
  GetResultPluginDetail,
  getResultPluginDetail,
  getSentFailedCaseList,
  getCancelVerifyCaseList,
  getTemplateProtectionFailureRate,
  getUnsentCaseList,
  getCaseLevelDistribution,
  getDeviceProtectionRanking,
  getVerifyResultDistribution,
  getTemplateNameList,
  getTaskDetailFilterData,
} from '@/api/endpoint-security/detail'
import { deleteList } from '@/api/endpoint-security/list'
import { addReport } from '@/api/evaluation'
import { Message } from '@/components/message'
import { t } from '@/i18n'

import { useRequest } from 'ahooks'

// 任务信息 任务进度
export const useGetResultInfo = () => {
  const { runAsync: run, data } = useRequest(params => getResultInfo(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取任务进度失败'))
    },
  })
  return [run, data?.data || {}] as const
}

// 获取用例列表
export const useGetUseCaseList = () => {
  const { runAsync: run, loading } = useRequest(params => getResultPluginList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取用例列表失败'))
    },
  })

  return [run, loading] as const
}

// 获取攻击类型
export const useGetAttackType = () => {
  const { runAsync: run, data } = useRequest(params => getAttackType(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取攻击类型失败'))
    },
  })

  return [run, data?.data?.attackTypeList || []] as const
}

// 获取ATT&CK
export const useGetAttck = () => {
  const { runAsync: run, data } = useRequest(params => getDetailAttCkList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取att&ck失败'))
    },
  })

  return [run, data?.data?.items || []] as const
}

// 获取关联安全设备
export const useGetDevices = () => {
  const { runAsync: run, data } = useRequest(params => getResultDeviceOption(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取关联安全设备失败'))
    },
  })

  return [run, data?.data?.items || []] as const
}

// 获取用例标签列表
export const useGetTagTreeOptions = () => {
  const { runAsync: run, data } = useRequest(params => getTagTreeOptions(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取标签列表失败'))
    },
  })

  return [run, data?.data?.categoryList || []] as const
}

// 更新资源拦截状态
export const useUpdateResourceInterceptStatus = () => {
  const { runAsync: run, loading } = useRequest(params => updateResourceInterceptStatus(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('更新资源拦截状态失败'))
    },
  })

  return [run, loading] as const
}

// 删除任务
export const useDeleteList = () => {
  const { runAsync: run } = useRequest(params => deleteList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除任务失败'))
    },
  })

  return [run] as const
}

// 生成报表
export const useAddReport = () => {
  const { runAsync: run, loading } = useRequest(params => addReport(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('报表添加失败'))
    },
  })

  return [run, loading] as const
}

// 获取离线日志导入信息
export const useGetOfflineLogImportInfo = () => {
  const { runAsync: run, data } = useRequest(params => getOfflineLogImportInfo(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取离线日志导入信息失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 删除日志设备导入记录
export const useDeleteOfflineLogImportInfo = () => {
  const { runAsync: run, loading } = useRequest(params => deleteOfflineLogImportRecord(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('删除日志设备导入记录失败'))
    },
  })

  return [run, loading] as const
}

// 获取拦截失败率（图表）
export const useGetFailRate = () => {
  const { runAsync: run, data } = useRequest(params => getResultRingPattern(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取拦截失败率失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 获取攻击防护排名 (轮播)
export const useGetProtectRate = () => {
  const { runAsync: run, data } = useRequest(params => getResultDefenseRankings(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取攻击防护排名失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 获取危险等级分布 (图表)
export const useGetRiskRate = () => {
  const { runAsync: run, data } = useRequest(params => getResultRiskLevel(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取危险等级分布失败'))
    },
  })

  return [run, data?.data?.items || []] as const
}

// 获取模板拦截失败率排名 (图表)
export const useGetTemplateFailureRate = () => {
  const { runAsync: run, data } = useRequest(params => getResultTemplateRankings(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取模板拦截失败率失败'))
    },
  })

  return [run, data?.data?.success_rate || []] as const
}

// 抽屉详情
export const useGetResultPluginDetail = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest((datas: GetResultPluginDetail) => getResultPluginDetail(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取插件详情失败'))
    },
  })
  return [run, data?.data || {}, loading] as const
}

// 获取执行失败用例列表
export const useGetSentFailedCaseList = () => {
  const { runAsync: run, data } = useRequest(params => getSentFailedCaseList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取执行失败用例列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 获取未执行用例列表
export const useGetUnsentCaseList = () => {
  const { runAsync: run, data } = useRequest(params => getUnsentCaseList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取未执行用例列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 获取取消验证用例列表
export const useGetCancelVerifyCaseList = () => {
  const { runAsync: run, data } = useRequest(params => getCancelVerifyCaseList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取取消验证用例列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 验证结果分布
export const useGetVerifyResultDistribution = () => {
  const { runAsync: run, data } = useRequest(params => getVerifyResultDistribution(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取验证结果分布失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 用例等级分布
export const useGetCaseLevelDistribution = () => {
  const { runAsync: run, data } = useRequest(params => getCaseLevelDistribution(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取用例等级分布失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 模板防护失效率排名
export const useGetTemplateProtectionFailureRate = () => {
  const { runAsync: run, data } = useRequest(params => getTemplateProtectionFailureRate(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取模板防护失效率排名失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 设备防护能力排名
export const useGetDeviceProtectionRanking = () => {
  const { runAsync: run, data } = useRequest(params => getDeviceProtectionRanking(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取设备防护能力排名失败'))
    },
  })

  return [run, data?.data?.devices || []] as const
}

// 获取模板名称列表
export const useGetTemplateNameList = () => {
  const { runAsync: run, data } = useRequest(params => getTemplateNameList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取模板名称列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 获取任务详情用例列表筛选数据
export const useGetTaskDetailFilterData = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailFilterData(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取任务详情用例列表筛选数据失败'))
    },
  })

  return [run, data?.data || {}] as const
}
